// 基础组件
export enum CustomBlocksType {
  MY_FIRST_BLOCK = 'MY_FIRST_BLOCK',
}
